import PropTypes from 'prop-types';
import React from 'react';

import { BadgeTypes } from '../../../../constants/Badge';
import Badge from '../../Badge/Badge';

import RowItemBadges from './RowItemBadges';

const RowItemSmallRowCollectedBadge = React.memo(
  ({ isRowSmall, isCollected, isInteractive, isFullRowLink }) => {
    if (isRowSmall && isCollected) {
      return (
        <RowItemBadges isInteractive={isInteractive} isFullRowLink={isFullRowLink}>
          <Badge badgeType={BadgeTypes.COLLECTED} isIcon={true} />
        </RowItemBadges>
      );
    }

    return null;
  },
);

RowItemSmallRowCollectedBadge.propTypes = {
  isRowSmall: PropTypes.bool,
  isCollected: PropTypes.bool,
  isInteractive: PropTypes.bool,
  isFullRowLink: PropTypes.bool,
};

export default RowItemSmallRowCollectedBadge;
